<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  response: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();

const hasAttachments = computed(() => props.response?.attachments?.length > 0);

const isImage = file =>
  file.file_type === 'image' ||
  /\.(png|jpe?g|gif|webp|svg)$/i.test(file.data_url || '');
</script>

<template>
  <div class="flex flex-col flex-1 min-w-0">
    <template v-if="response">
      <div class="px-4 py-3 border-b border-n-weak">
        <h3 class="text-sm font-medium text-n-slate-12 truncate">
          {{ response.short_code }}
        </h3>
      </div>
      <div class="flex-1 overflow-y-auto p-4">
        <p class="text-sm text-n-slate-12 whitespace-pre-wrap break-words">
          {{ response.content }}
        </p>
        <div v-if="hasAttachments" class="mt-3 pt-3 border-t border-n-weak">
          <p class="text-xs font-medium text-n-slate-11 mb-2">
            {{
              t('CANNED_RESPONSE_BROWSER.ATTACHMENTS', {
                count: response.attachments.length,
              })
            }}
          </p>
          <div class="flex flex-col gap-2">
            <div
              v-for="file in response.attachments"
              :key="file.id"
              class="flex items-center gap-2 rounded-lg border border-n-weak p-2"
            >
              <img
                v-if="isImage(file)"
                :src="file.data_url"
                :alt="file.filename"
                class="size-10 rounded object-cover"
              />
              <span
                v-else
                class="flex size-10 items-center justify-center rounded bg-n-alpha-2"
              >
                <fluent-icon icon="document" size="16" />
              </span>
              <span class="flex-1 truncate text-xs text-n-slate-12">
                {{ file.filename || t('CANNED_RESPONSE_BROWSER.UNNAMED_FILE') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div
      v-else
      class="flex flex-1 items-center justify-center text-sm text-n-slate-10"
    >
      {{ t('CANNED_RESPONSE_BROWSER.SELECT_TO_PREVIEW') }}
    </div>
  </div>
</template>
